







































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseCours from '@/components/administration/cours/edit/EditBaseCours.vue'
import * as rules from '@/utils/validationRules'
import { toStringDictionary } from '@/utils/groupBy'
import { getDefaultAloCours } from '@/models/alo/AloCours'
import { AloCours } from '@/models/alo/AloCours'
import { formatDate } from '@/filters/formatDate'
import { getDefaultAloActivity } from '@/models/alo/AloActivity'
import { AloPiscine, getDefaultAloPiscine } from '@/models/alo/AloPiscine'
import { AloInscription } from '@/models/alo/AloInscription'
import { StatusInscription } from '@/enum/StatusInscription'
import api, { directPayloadQuery } from '@/utils/api'
import apiUser from '@/api/user'
import apiFamily from '@/api/family'
import { AlsUser } from '@/models/als/AlsUser'
import SearchDialog from '@/components/shared/SearchDialog.vue'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import { AloUser } from '@/models/alo/AloUser'

@Component({
  name: 'EditComposition',     
  components:{EditBaseCours}
})
export default class EditComposition extends Vue {
      
  private cours:AloCours = getDefaultAloCours()  
  private heures = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]
  private minutes = [0,5,10,15,20,25,30,35,40,45,50,55,60]
  private reserving = false

  get dateCours() {
    return formatDate(this.cours.crsDatdebut,"YYYY-MM-DD") 
  }

  private headers = [                   
    
    { text: '', value: 'email', width:50 }, 
    { text: 'Status', value: 'isnStatus',width:140},           
    { text: 'Participant', value: 'libelle'},       
    { text: 'Date', value: 'isnDatinscription',width:160}
  ]

  get emails(){
    return  this.cours.inscriptions.filter(i => i.isnStatus <= StatusInscription.present).map(i => i.email).join(';')
  }

  set dateCours(newValue){
    this.cours.crsDatdebut = `${formatDate(newValue,"YYYY-MM-DD")}T${formatDate(this.cours.crsDatdebut,"HH:mm:ss")}`
  }

  get heureCours()  {
    return Number.parseInt(formatDate(this.cours.crsDatdebut,"HH"))
  }

  set heureCours(newValue)  {
    this.cours.crsDatdebut = `${formatDate(this.cours.crsDatdebut,"YYYY-MM-DD")}T${newValue.toString().padStart(2,'0')}:${formatDate(this.cours.crsDatdebut,"mm")}:00`
  }

  get minuteCours()  {
    return Number.parseInt(formatDate(this.cours.crsDatdebut,"mm"))
  }

  set minuteCours(newValue)  {
    this.cours.crsDatdebut = `${formatDate(this.cours.crsDatdebut,"YYYY-MM-DDTHH:")}${newValue.toString().padStart(2,'0')}:00`
  }

  get activitySecondaire(){
    return [
      {
        ...getDefaultAloActivity(),libelle:"Aucune"},
        ...this.activityList.filter(a => a.id != this.cours.acyId)
      ]
  }

  get piscine(){    
    return this.$store.myGetters.piscineDic[this.cours.psnId!] ?? getDefaultAloPiscine()
  }

  get StatusAnnulee(){
    return StatusInscription.annulee
  }
  
  get activityList() {
    return this.$store.myGetters.activityList
  }

  get  extendHeader() {
    return  [
      { text: 'Ville', value: 'address.libelle', width:250 }      
    ]
  }

  edit(item:AloCours) {    
    this.cours = (this.$refs.baseEdit as EditBaseCours).edit(item)
    this.$store.myActions.ADM_PISCINE_DETAIL_ENSURE(this.cours.psnId!)
  }

 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }  

  annuleCours(item:AloInscription){
    item.isnStatus = StatusInscription.annulee
    item.isnDatannulation = formatDate(new Date(),'YYYY-MM-DDTHH:mm:00')
  }

  presentCours(item:AloInscription){  
    item.isnStatus = StatusInscription.present  
  }

  abscentCours(item:AloInscription){
    item.isnStatus = StatusInscription.abscent
  }

  created(){
    this.$store.myActions.ADM_ACTIVITY_ENSURE()
  }

  addInscription(){
    (this.$refs.search as SearchDialog).show()
  }

  addNewInscription(user:AloUser) {
    this.reserving = true
    this.$confirm(`Confirmer l'inscription de ${user.libelle} à ce cours`,{title: 'Confirmer le choix',buttonTrueText:"Oui",buttonFalseText:"Non"} as VuetifyConfirmObject).then((answer)=>{
      if(answer){
        directPayloadQuery(apiFamily.inscription,{usrId:user.id,crsId:this.cours.id}).then((resaOk:boolean)=>{          
          if(resaOk) {                
            this.$confirm("l'inscription à bien été prise en comptes",{title: 'Inscription validée',buttonTrueText:"Fermer",buttonFalseText:""} as VuetifyConfirmObject)               
            //raffraichi les données du cours
            this.$store.myActions.ADM_COURS_DETAIL_REQUEST(this.cours.id)
          }    
        })
        .catch((error)=>{      
          this.$confirm(error,{title: 'Erreur',buttonTrueText:"Fermer",buttonFalseText:""} as VuetifyConfirmObject)
        })
        .finally(()=>{
          this.reserving = false
        })    
      }
    })    
  }

  searchUser(txt:string)  {
    return directPayloadQuery(apiUser.getFilterUser,{
      libelle:txt
    } as AlsUser)
  }
      
}
